<template lang="html">
  <div class="payments-component">
    <h2 class="text-center">Pénzügyek</h2>
    <v-container>
      <v-progress-linear
            v-if="loading"
            indeterminate
            color="red"
      ></v-progress-linear>
      <v-row justify="center">
      <p v-if="!loading && student_payments == ''">A szerződéshez még nem tartoznak befizetések</p>
      </v-row>
      <v-data-table
        v-if="student_payments != ''"
        :headers="payments_header"
        :items="student_payments"
        class="elevation-1"
        :items-per-page="20"
        hide-default-footer
        hide-default-header
        show-expand
      >
      <template
        v-slot:header="{ props: { headers, mobile } }"
      >
        <thead v-if="!mobile">
          <tr>
            <th></th>
            <th class="text-left">Összeg</th>
            <th class="text-left">Termék</th>
            <th class="text-left">Státusz</th>
            <th class="text-left">Fizetési mód</th>
            <th class="text-left">Befizetés ideje</th>
            <th class="text-left">Kiegyenlítve</th>
            <th class="text-left">Számlaszám</th>
          </tr>
        </thead>
      </template>

      <template v-slot:item.data-table-expand="{ item }">
        <v-btn
          color="primary"
          icon
          v-if="item.billingo_id"
          @click="downloadInvoice(item.billingo_id, item.invoice_number)"
          :loading="preloader"
        >
        <v-icon dark>save</v-icon>
        </v-btn>
      </template>

      </v-data-table>
  </v-container>
  </div>
</template>

<script>
import {mapFields} from 'vuex-map-fields';
import { EventBus } from '../event-bus';

  export default {
    data () {
      return {
        loading: false,
        student_payments: '',
        payments_header: [
          { text: 'Összeg', value: 'amount'},
          { text: 'Termék', value: 'item_name' },
          { text: 'Státusz', value: 'status' },
          { text: 'Fizetési mód', value: 'payment_type' },
          { text: 'Befizetés ideje', value: 'invoice_date' },
          { text: 'Kiegyenlítve', value: 'paid_date' },
          { text: 'Számlaszám', value: 'invoice_number' },
        ],
      }
    },
    methods: {
      getPayments: async function() {
        this.loading = true
        await this.gettoken()
        this.$http.post('/adatok/diakok_befizetes', {
          token: this.token,
          contract_id: this.contract_id
        }).then((response) => {
          this.loading = false
          this.student_payments = response.data

        }, (error) => {
          console.log(error.data);
        })
      },
      downloadInvoice: async function(billingo_id, invoice_number) {
        this.preloader = true
        await this.gettoken()
        this.$http.post('tanfolyam/download_invoice', {
          token: this.token,
          school_id: this.contract_driving_school,
          invoice_id: billingo_id
        }, {responseType: 'blob'}).then((response) => {
          this.preloader = false
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', invoice_number+'.pdf');
          document.body.appendChild(link);
          link.click();
        }, (error) => {
          this.error_text = error.data
        })
      },
    },
    mounted() {
      if (this.contract_id) {
        this.getPayments()
      }
    },
    watch: {
      contract_id() {
          this.getPayments()
      },
    },
    created() {
      EventBus.$on('refreshPayments', () => {
            this.getPayments();
      })
    },
    computed: {
    ...mapFields([
    'ids.contract_id',
    'ids.contract_driving_school',
    'actions.preloader',
  ]),
  },
  }
</script>

<style lang="css">

</style>
